<h2 class="text-center mb-4">Create your account</h2>
<p *ngIf="isRegistrationError && registrationErrorMsg" class="alert alert-warning font-weight-bold text-center" role="alert">{{registrationErrorMsg}}</p>
<div *ngIf="showSuccessPane && registrationMsg">
  <p class="alert alert-success font-weight-bold text-center" role="status">{{registrationMsg}}</p>
  <p class="text-links-wrap">
    <a routerLink="/access/login" class="text-link">Back to login</a>
    <a routerLink="/access/resendemailverification" class="text-link text-right">Resend verification email</a>
  </p>
</div>
<form *ngIf="!showSuccessPane" [formGroup]="registrationForm" class="m-0" (ngSubmit)="OnSubmit()">
  <div class="fieldset">
    <label for="Name" class="legend">Full Name</label>
    <input type="text" name="Name" id="Name" class="text-field" formControlName="fullname" autocomplete="name" required>
    <div class="formError" *ngIf="registrationForm.get('fullname')?.invalid && registrationForm.get('fullname')?.touched">
      <span *ngIf="registrationForm.get('fullname')?.hasError('required')">Full-name is required</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" formControlName="email" autocomplete="email" required>
    <div class="formError" *ngIf="registrationForm.get('email')?.invalid && registrationForm.get('email')?.touched">
      <span *ngIf="registrationForm.get('email')?.hasError('required')">Email is required</span>
      <span *ngIf="registrationForm.get('email')?.hasError('email')">Enter a valid email</span>
    </div>
  </div>
  <div class="fieldset">
      <label for="preSelectedCountryCode" class="legend">Phone</label>
      <div>
        <select name="preSelectedCountryCode" class="text-field col-4 d-inline" id="preSelectedCountryCode" formControlName="countrycode"
        (change)="onCountryCodeChange()" required >
          <option *ngFor="let countryCode of countryCodes" [value]="countryCode.Code">{{countryCode.Country}}: {{countryCode.Code}} </option>
        </select>
        <input type="tel" name="Phone" id="Phone" class="text-field col-8 d-inline" formControlName="phone" autocomplete="tel-national" required>
      </div>
      <div class="formError" *ngIf="registrationForm.get('phone')?.invalid && registrationForm.get('phone')?.touched">
        <div *ngIf="registrationForm.get('phone')?.hasError('invalidPhoneNumber')">Invalid phone number format</div>
        <span *ngIf="registrationForm.get('phone')?.hasError('required')">Phone number is required</span>
      </div>
    </div>
  <div class="fieldset">
    <label for="Password" class="legend">Password</label>
    <div class="password-field">
      <input [type]="showPassword ? 'text' : 'password'" name="Password" id="Password" class="text-field" formControlName="password" autocomplete="new-password" required>
      <button type="button" class="password-toggle" (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
        <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
      </button>
    </div>
    <app-password-strength *ngIf="registrationForm.get('password')?.touched" [password]="registrationForm.get('password')?.value"></app-password-strength>
    <div class="formError" *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched">
      <span *ngIf="registrationForm.get('password')?.hasError('required')">Password is required</span>
      <span *ngIf="registrationForm.get('password')?.hasError('maxlength')">Password cannot exceed 64 characters</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="CPassword" class="legend">Confirm Password</label>
    <div class="password-field">
      <input [type]="showCPassword ? 'text' : 'password'" name="CPassword" id="CPassword" class="text-field" formControlName="cpassword" autocomplete="new-password" required>
      <button type="button" class="password-toggle" (click)="showCPassword = !showCPassword"
              [attr.aria-label]="showCPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showCPassword">
        <i class="fa" [class.fa-eye]="!showCPassword" [class.fa-eye-slash]="showCPassword"></i>
      </button>
    </div>
    <div class="formError" *ngIf="registrationForm.get('cpassword')?.invalid && registrationForm.get('cpassword')?.touched">
      <span >Passwords do not match</span>
    </div>
  </div>
  <button *ngIf="!this.registrationService_.isLoading; else isLoading" type="submit" class="btn m-auto" [disabled]="registrationForm.invalid">Register</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Registering...</button>
  </ng-template>
  <div class="fieldset mt-3">
    <p class="text-center text-sm mb-1">Or</p>
    <hr class="m-0 mb-2"/>
      <iframe [src]="googleauthuri" title="Sign up with Google" width="100%" height="50px" scrolling="no" frameborder="0"></iframe>
  </div>
</form>
